interface HoverAreaProps {
  side: 'left' | 'right';
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
  expandedSection: 'left' | 'right' | null;
  hasExpanded: boolean;
}

const HoverArea = ({ side, onMouseEnter, onMouseLeave, onClick, expandedSection, hasExpanded }: HoverAreaProps) => {
  const isExpanded = expandedSection === side;
  const width = isExpanded ? '100%' : '50%';
  const left = isExpanded ? '0' : side === 'left' ? '0' : '50%';

  return (
    <div
      className="absolute top-0 h-full z-[2]"
      style={{
        left,
        width,
        cursor: hasExpanded ? 'default' : 'pointer',
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={hasExpanded ? undefined : onClick}
    />
  );
};

export default HoverArea;
